import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IUser, IUserUpdateParams } from '@core/interfaces/user';
export const UserActions = createActionGroup({
  source: 'USER ADMIN',
  events: {
    attemptSelectUser: props<{ id: string | null }>(),
    selectUser: props<{ id: string | null }>(),
    requestUserInfo: props<{ id: string }>(),
    requestUserInfoSuccess: props<{ id: string; user: IUser }>(),
    requestUserInfoError: props<{ id: string; error: string }>(),
    save: props<{ id: string; params: IUserUpdateParams }>(),
    saved: props<{ id: string }>(),
    failed: props<{ error: string }>(),
    commandStarted: emptyProps(),
    commandFinished: emptyProps(),
    setFormValues: props<{ hasChanges: boolean }>(),
    closeUser: emptyProps(),
    clearUser: emptyProps(),
  },
});
